(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customgrid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === '{{ section.id }}') {
    initializeSlider(event.target);
  }
});

// Initialize sliders that exist on page load
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.custom-grid-slider');
  sliders.forEach(slider => {
    initializeSlider(slider);
  });
});

function initializeSlider(container) {
  const slider = container.querySelector('[data-slider]');
  const items = slider.querySelectorAll('.custom-grid-slider__item');
  const prevButton = container.querySelector('[data-slider-prev]');
  const nextButton = container.querySelector('[data-slider-next]');
  const pagination = container.querySelector('[data-pagination]');
  
  let currentIndex = 0;
  let itemsPerView = getItemsPerView();
  let isDragging = false;
  let startX = 0;
  let translateX = 0;
  let startTranslateX = 0;
  
  // Initialize pagination dots
  initializePagination();
  
  // Update navigation button state
  updateButtonState();
  
  // Desktop navigation
  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSliderPosition();
        updateButtonState();
        updatePagination();
      }
    });
    
    nextButton.addEventListener('click', () => {
      if (currentIndex < items.length - itemsPerView) {
        currentIndex++;
        updateSliderPosition();
        updateButtonState();
        updatePagination();
      }
    });
  }
  
  // Mobile touch/swipe functionality
  if (window.innerWidth <= 767) {
    initializeMobileSwiper();
  }
  
  // Update slider on window resize
  window.addEventListener('resize', () => {
    const oldItemsPerView = itemsPerView;
    itemsPerView = getItemsPerView();
    
    // Reinitialize mobile swiper if switching to/from mobile
    if (window.innerWidth <= 767 && oldItemsPerView !== 1) {
      initializeMobileSwiper();
    }
    
    // Reset position if needed
    if (currentIndex > items.length - itemsPerView) {
      currentIndex = Math.max(0, items.length - itemsPerView);
    }
    
    updateSliderPosition();
    updateButtonState();
    updatePagination();
  });
  
  function getItemsPerView() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 768) return 1;
    if (windowWidth < 990) return 2;
    return 3;
  }
  
  function initializePagination() {
    if (!pagination) return;
    
    pagination.innerHTML = '';
    const totalSlides = items.length;
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('button');
      dot.className = 'custom-grid-slider__swiper-dot';
      if (i === currentIndex) dot.classList.add('active');
      dot.addEventListener('click', () => {
        currentIndex = i;
        updateSliderPosition();
        updatePagination();
      });
      pagination.appendChild(dot);
    }
  }
  
  function updatePagination() {
    if (!pagination) return;
    
    const dots = pagination.querySelectorAll('.custom-grid-slider__swiper-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }
  
  function initializeMobileSwiper() {
    // Remove existing event listeners
    slider.removeEventListener('mousedown', handleStart);
    slider.removeEventListener('touchstart', handleStart);
    
    // Add touch event listeners for mobile
    slider.addEventListener('touchstart', handleStart, { passive: false });
    slider.addEventListener('touchmove', handleMove, { passive: false });
    slider.addEventListener('touchend', handleEnd);
    
    // Add mouse event listeners for desktop testing
    slider.addEventListener('mousedown', handleStart);
    slider.addEventListener('mousemove', handleMove);
    slider.addEventListener('mouseup', handleEnd);
    slider.addEventListener('mouseleave', handleEnd);
  }
  
  function handleStart(e) {
    if (window.innerWidth > 767) return; // Only on mobile
    
    isDragging = true;
    slider.classList.add('dragging');
    
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    startX = clientX;
    
    // Get current transform value
    const transform = window.getComputedStyle(slider).transform;
    if (transform !== 'none') {
      const matrix = new DOMMatrix(transform);
      startTranslateX = matrix.m41;
    } else {
      startTranslateX = 0;
    }
    
    slider.style.transition = 'none';
    e.preventDefault();
  }
  
  function handleMove(e) {
    if (!isDragging || window.innerWidth > 767) return;
    
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - startX;
    translateX = startTranslateX + deltaX;
    
    // Apply some resistance at the boundaries
    const containerWidth = slider.offsetWidth;
    const maxTranslate = 0;
    const minTranslate = -(items.length - 1) * (containerWidth * 0.8 + 20);
    
    if (translateX > maxTranslate) {
      translateX = maxTranslate + (translateX - maxTranslate) * 0.3;
    } else if (translateX < minTranslate) {
      translateX = minTranslate + (translateX - minTranslate) * 0.3;
    }
    
    slider.style.transform = `translateX(${translateX}px)`;
    e.preventDefault();
  }
  
  function handleEnd(e) {
    if (!isDragging || window.innerWidth > 767) return;
    
    isDragging = false;
    slider.classList.remove('dragging');
    slider.style.transition = 'transform 0.3s ease-out';
    
    const containerWidth = slider.offsetWidth;
    const slideWidth = containerWidth * 0.8 + 20; // 80% + gap
    const deltaX = translateX - startTranslateX;
    const threshold = slideWidth * 0.25; // 25% of slide width
    
    // Determine target slide based on current position and swipe direction
    let targetIndex = Math.round(-translateX / slideWidth);
    
    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0 && currentIndex > 0) {
        targetIndex = currentIndex - 1;
      } else if (deltaX < 0 && currentIndex < items.length - 1) {
        targetIndex = currentIndex + 1;
      }
    } else {
      targetIndex = currentIndex;
    }
    
    // Ensure target index is within bounds
    targetIndex = Math.max(0, Math.min(items.length - 1, targetIndex));
    currentIndex = targetIndex;
    
    updateSliderPosition();
    updatePagination();
  }
  
  function updateSliderPosition() {
    if (window.innerWidth <= 767) {
      // Mobile: seamless scrolling with 80% width slides
      const containerWidth = slider.offsetWidth;
      const slideWidth = containerWidth * 0.8 + 20; // 80% width + 20px gap
      const slideAmount = currentIndex * slideWidth;
      slider.style.transform = `translateX(-${slideAmount}px)`;
    } else {
      // Desktop: use existing logic
      const itemWidth = items[0].offsetWidth;
      const gap = 20;
      const slideAmount = currentIndex * (itemWidth + gap);
      slider.style.transform = `translateX(-${slideAmount}px)`;
    }
  }
  
  function updateButtonState() {
    if (prevButton) {
      prevButton.disabled = currentIndex === 0;
    }
    
    if (nextButton) {
      nextButton.disabled = currentIndex >= items.length - itemsPerView;
    }
    
    // Always show both buttons visually, even if disabled
    if (items.length <= itemsPerView) {
      // If we don't have enough items to scroll, disable both buttons
      if (prevButton) prevButton.disabled = true;
      if (nextButton) nextButton.disabled = true;
    }
  }
}

  } catch(e) { console.error(e); }
})();
})();
